/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Loader from 'material/loader/loader';
import UnsavedMessage from 'material/message/popup/unsaved/unsaved_container';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/button/button_styles';



/* ========== ~~~~~~~~~~ BUTTON : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Button = (props) => {
	const handleOperationText = () => {
		switch (props.operation) {
			case 'save':
				return `Saving ...`;
			case 'discard':
				return `Discarding ...`;
			case 'delete':
				return `Deleting ...`;
			case 'create':
                return `Creating ...`;
            case 'run':
                return `Running ...`;
            case 'download':
                return `Downloading ...`;
			case 'load':
			default:
				return `Loading ...`;
		}
	};
	const handleText = () => {
		return props.processing ? handleOperationText() : props.text;
	};
	const handleIcon = () => {
		return props.processing ? null : props.icon;
	};
	const handleClick = (e) => {
		// prevent default action on click
		e.preventDefault();
		// if we have a handler passed as a prop execute it (make sure this is FIRST to execute for things like state changes)
		if (props.handleClick) props.handleClick(e);
		// handle different link type cases
		switch (props.type) {
			case 'modal':
				props.action === false ?
					props.displayModal(false)
					:
					props.displayModal(true, props.action)
				;
				break;
			case 'custom':
				break;
			case 'action':
				if (props.action) props.action();
				break;
            case 'action_route':
                if(props.editMode){
                    displayWarning(props.action);
                    return;
                }
                if (props.action) props.action();
                break;
            case 'scroll':
                // action = ref in this case
                // scroll to specific ref (DOM element)
                window.scrollTo(0, props.action.offsetTop);
                break;
            case 'external':
                if(props.editMode){
                    displayWarning(()=>window.open(props.action));
                    return;
                }
                window.open(props.action);
                break;
            case 'internal':
                if(props.editMode){
                    displayWarning(()=>props.moveToPage(props.action));
                    return;
                }
                props.moveToPage(props.action);
                break;
            default:
                break;
		}
	};
    const displayWarning = (action) => props.displayModal(true, <UnsavedMessage primaryAction={action} />);
	return (
        <button className={`button ${generateClasses(props, ['iconRight'])} ${props.classes.button} ${props.klass} processing-${props.processing}`} disabled={!!props.disabled} onClick={handleClick}>
			{!props.removeLoaderIcon && <Loader />}
        	{handleIcon()}
        	<span className={`text`}>{handleText()}</span>
        </button>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Button);